// src/pages/Chat/ChatSidebar.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import KebabMenu from './KebabMenu';

// --- MODIFICATION 1: Accept new props ---
const ChatSidebar = ({
    chats,
    activeChatId,
    onCreateChat,
    onDeleteChat,
    onSelectChat,  // For mobile UX
    isCollapsed,   // To handle mobile toggle
    loading,
    error,
}) => {
    const { t } = useTranslation();

    // --- MODIFICATION 2: Handle collapsed state ---
    // If the sidebar is collapsed (on mobile), render nothing.
    if (isCollapsed) {
        return null;
    }
    
    const handleCopy = (chatIdToCopy) => {
        const chatToCopy = chats.find(chat => chat.chat_id === chatIdToCopy);
        if (chatToCopy && chatToCopy.title) {
            navigator.clipboard.writeText(chatToCopy.title)
                .then(() => console.log(`Copied "${chatToCopy.title}"`))
                .catch(err => console.error('Failed to copy: ', err));
        }
    };
    
    const confirmAndDelete = (chatIdToDelete) => {
        if (window.confirm(t('chat.sidebar.confirmDelete'))) {
            onDeleteChat(chatIdToDelete);
        }
    };
    
    return (
        // --- MODIFICATION 3: Make width flexible ---
        // Removed `w-64` and `flex-shrink-0`. Added `h-full`, `w-full` and `overflow-hidden`
        // so it perfectly fills the resizable container from ChatPage.
        <aside className="h-full w-full bg-brand-white p-4 flex flex-col border-r border-slate-700 text-black overflow-hidden">
            <div className="flex-shrink-0">
                <button
                    onClick={onCreateChat}
                    className="w-full mb-4 px-4 py-2 bg-brand-orange hover:bg-orange-600 text-white font-semibold rounded-md transition-colors"
                >
                    {t('chat.sidebar.newChatButton')}
                </button>
            </div>
            
            <div className="flex-1 overflow-y-auto min-h-0">
                {loading && <p className="text-gray-400">{t('chat.sidebar.loadingChats')}</p>}
                {error && <p className="text-red-500">{error}</p>}
                {!loading && !error && (
                    <ul>
                        {chats.map(chat => {
                            const isActive = chat.chat_id === activeChatId;
                            return (
                                <li key={chat.chat_id} className="group relative mb-2">
                                    <Link
                                        to={`/chat/${chat.chat_id}`}
                                        // --- MODIFICATION 4: Add onClick for mobile UX ---
                                        onClick={onSelectChat}
                                        className={`block w-full text-left p-2 pr-10 rounded-md truncate ${
                                            isActive 
                                                ? 'bg-brand-dark text-white' 
                                                : 'hover:bg-brand-dark'
                                        }`}
                                    >
                                        {chat.title || t('chat.newChat')}
                                    </Link>
                                    
                                    <div className="absolute inset-y-0 right-0 flex items-center pr-2 opacity-0 group-hover:opacity-100 transition-opacity">
                                        <KebabMenu 
                                            chatId={chat.chat_id}
                                            onDelete={confirmAndDelete}
                                            onCopy={handleCopy}
                                        />
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>
        </aside>
    );
};

export default ChatSidebar;